// social proof ( usps ) slider

$(function () {
  function slidersInit() {
    $(".USP_slider").slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      focusOnSelect: true,
      asNavFor: ".social-ups-lists",
    });

    $(".social-ups-lists").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      asNavFor: ".USP_slider",
      dots: false,
      arrows: false,
      fade: false,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  }
  slidersInit();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit();
    });
  }
});

// instagram slider

$(function () {
  function slidersInit3() {
    $(".instagram-posts").slick({
      dots: true,
      prevArrow: $(".instagram-arrows .slick-left-arrow"),
      nextArrow: $(".instagram-arrows .slick-right-arrow"),
      dotsClass: "instagram-dots",
      arrows: true,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 3.85,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1.5,
          },
        },
      ],
    });
  }
  slidersInit3();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit3();
    });
  }
});

// product grid wrap mixed product
$(function () {
  function slidersInit4() {
    $(".product-grid-wrap_mixed_product").slick({
      dots: false,
      dotsClass: "instagram-dots",
      prevArrow: $(".featured-arrows .slick-left-arrow"),
      nextArrow: $(".featured-arrows .slick-right-arrow"),
      arrows: true,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 3.45,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToScroll: 1,
            slidesToShow: 1.25,
          },
        },
      ],
    });
  }
  slidersInit4();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit4();
    });
  }
});

// reviews slider
$(function () {
  function slidersInit5() {
    $(".review-slider").slick({
      dots: true,
      dotsClass: "review-dots",
      arrows: true,
      prevArrow: $(".review-arrows .slick-left-arrow"),
      nextArrow: $(".review-arrows .slick-right-arrow"),
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
          },
        },
      ],
    });
  }
  slidersInit5();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit5();
    });
  }
});

// PRODUCT SLIDERS

$(function () {
  function slidersInit6() {
    $(".product-slider").slick({
      dots: false,
      dotsClass: "instagram-dots",
      arrows: false,
      fade: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: ".product-thumbnails",
      responsive: [
        {
          breakpoint: 1099,
          settings: {
            dots: true,
          },
        },
      ],
    });

    $(".product-thumbnails").slick({
      slidesToShow: 4.75,
      slidesToScroll: 1,
      asNavFor: ".product-slider",
      dots: false,
      arrows: false,
      fade: false,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
    });
  }
  slidersInit6();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit6();
    });
  }
});

// MEGA MENU

$(function () {
  function slidersInit7() {
    $(".header_cards").slick({
      dots: false,
      arrows: true,
      prevArrow: $(".mega-menu-arrows .mega-cards-prev"),
      nextArrow: $(".mega-menu-arrows .mega-cards-next"),
      fade: false,
      infinite: false,
      slidesToShow: 3.3,
      slidesToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }
  slidersInit7();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit7();
    });
  }
});

$(function () {
  function slidersInit8() {
    if ($(window).width() > 768) {
      if ($(".pods_images_wrap_wrapper").length > 3) {
        $(".pods_lifestyle_wrapper").slick({
          dots: false,
          prevArrow: $(".featured-arrows .slick-left-arrow"),
          nextArrow: $(".featured-arrows .slick-right-arrow"),
          arrows: true,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 3,
              },
            },
          ],
        });
      } else {
        $(".pods_lifestyle_images .featured-arrows").css("display", "none");
      }
    } else {
      if ($(".pods_images_wrap_wrapper").length > 2) {
        $(".pods_lifestyle_wrapper").slick({
          dots: false,
          prevArrow: $(".featured-arrows .slick-left-arrow"),
          nextArrow: $(".featured-arrows .slick-right-arrow"),
          arrows: true,
          infinite: false,
          slidesToScroll: 1,
          slidesToShow: 2.2,
        });
      } else {
        $(".pods_lifestyle_images .featured-arrows").css("display", "none");
      }
    }
  }
  slidersInit8();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit8();
    });
  }
});


$(function () {
  function slidersInit9() {
    $(".moving-title-carousel-posts").slick({
      dots: false,
      prevArrow: $(".moving-title-carousel-previous"),
      nextArrow: $(".moving-title-carousel-next"),
      arrows: true,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 5,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            dots: true,
            slidesToShow: 2.5,
            slidesToScroll: 1,
            dotsClass: "instagram-dots",
            centerMode: true,
            arrows: false,
            infinite: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1.4,
            dots: true,
            dotsClass: "instagram-dots",
            centerMode: true,
            arrows: false,
            infinite: false,
          },
        },
      ],
    });
  }
  slidersInit9();

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      slidersInit9();
    });
  }
});
